// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"376":"empresa-qr","862":"comp"}[chunkId] + "." + {"376":"90866538","862":"4f5bb9fd"}[chunkId] + ".js";
};